import Button from "@Components/Button";
import styles from "./HeroContent.module.scss";
import GalleryIcon from "@Icons/Gallery_icon";
import FlagLight from "@Icons/FlagLight";
import PayoutDisbursedIcon from "@Icons/PayoutDisbursedIcon";
import wrapperHOC from "@Utils/wrapperHOC";
import { useContext } from "react";
import { ScholarshipFormContext } from "@Pages/Scholarship/ScholarshipFormModal";
import useTranslationHook from "hooks/useTranslationHook";

const HeroContent = () => {
  const { openForm } = useContext(ScholarshipFormContext);
  const { t } = useTranslationHook();

  return (
    <div className={styles.contentChildContainer}>
      <div className={styles.headingContainer}>
        <h1 className={styles.headingWrapper}>
          <span className={styles.headingDesktop}>
            {t("scholarship.herov2.herocontent.heading")}
          </span>
          <span className={styles.headingTablet}>
            {t("scholarship.herov2.herocontent.headingtablet.part1")} <br />{" "}
            {t("scholarship.herov2.herocontent.headingtablet.part2")}
          </span>
        </h1>
        <p className={styles.contentWrapper}>{t("scholarship.herov2.herocontent.description")}</p>
      </div>

      <div className={styles.deadlinetextContainer}>
        <Button variant="none" className={styles.scholarshipButton} onClick={openForm}>
          {t("scholarship.herov2.herocontent.applynow")}
        </Button>
        <p>{t("scholarship.herov2.herocontent.deadline")}</p>
      </div>

      {/* Form modal is now managed by ScholarshipFormContext in parent */}

      <div className={styles.refStatsContainer}>
        <div className={styles.refStatsChildContainer}>
          <div className={styles.refImageContainer}>
            <GalleryIcon />
          </div>
          <div className={styles.refContentContainer}>
            <div className={styles.refContentHeading}>
              {t("scholarship.herov2.herocontent.applicants.count")}
            </div>
            <div className={styles.refContentSubHeading}>
              {t("scholarship.herov2.herocontent.applicants.label")}
            </div>
          </div>
        </div>
        <div className={styles.refSeprator} />
        <div className={styles.refStatsChildContainer}>
          <div className={styles.refImageContainer}>
            <FlagLight />
          </div>
          <div className={styles.refContentContainer}>
            <div className={styles.refContentHeading}>
              {t("scholarship.herov2.herocontent.nationalities.count")}
            </div>
            <div className={styles.refContentSubHeading}>
              {t("scholarship.herov2.herocontent.nationalities.label")}
            </div>
          </div>
        </div>
        <div className={styles.refStatsDividor} />
        <div className={styles.refStatsChildContainer}>
          <div className={styles.refImageContainer}>
            <PayoutDisbursedIcon />
          </div>
          <div className={styles.refContentContainer}>
            <div className={styles.refContentHeading}>
              {t("scholarship.herov2.herocontent.scholarships.amount")}
            </div>
            <div className={styles.refContentSubHeading}>
              {t("scholarship.herov2.herocontent.scholarships.label")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default wrapperHOC(HeroContent, {
  componentName: "HeroContent-ScholarshipDesktop",
  showForChina: true,
});
